import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  TbLayoutSidebarLeftCollapseFilled,
  TbLayoutSidebarRightCollapseFilled,
} from "react-icons/tb";

const TrimText = ({ text, index, maxLen = 20 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Handle null/undefined/empty text
  const safeText = typeof text === "string" && text.trim() !== "" ? text : "-";

  // Determine if text needs trimming
  const needsTrimming = safeText.length > maxLen;

  // Trim text to maxLen characters if not expanded and needs trimming
  const displayText =
    isExpanded || !needsTrimming ? safeText : `${safeText.slice(0, maxLen)}...`;

  // Unique key for buttons to avoid conflicts in lists
  const buttonId = `trim-text-button-${
    index !== undefined ? index : Math.random().toString(36).substr(2, 9)
  }`;

  // Toggle expanded state
  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="flex items-end gap-2">
      <span className="text-gray-800">{displayText}</span>
      {needsTrimming && (
        <button
          type="button"
          className=" text-sm font-medium"
          onClick={(e) => {
            e.stopPropagation();
            handleToggle();
          }}
          aria-expanded={isExpanded}
          aria-controls={buttonId}
        >
          {isExpanded ? (
            <TbLayoutSidebarLeftCollapseFilled
              size={12}
              className="text-red-600 hover:text-red-800"
            />
          ) : (
            <TbLayoutSidebarRightCollapseFilled
              size={12}
              className="text-green-600 hover:text-green-800"
            />
          )}
        </button>
      )}
    </div>
  );
};

// PropTypes for type checking
TrimText.propTypes = {
  text: PropTypes.string,
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

// Default props for edge cases
TrimText.defaultProps = {
  text: "",
  index: undefined,
};

export default TrimText;

// import React, { useState } from "react";
// import PropTypes from "prop-types";
// import {
//   TbLayoutSidebarLeftCollapseFilled,
//   TbLayoutSidebarRightCollapseFilled,
// } from "react-icons/tb";

// const TrimText = ({ text, index, maxLen = 20 }) => {
//   const [isExpanded, setIsExpanded] = useState(false);

//   // Handle null/undefined/empty text
//   const safeText = typeof text === "string" && text.trim() !== "" ? text : "-";

//   // Determine if text needs trimming
//   const needsTrimming = safeText.length > maxLen;

//   // Trim text to maxLen characters if not expanded and needs trimming
//   const displayText =
//     isExpanded || !needsTrimming ? safeText : `${safeText.slice(0, maxLen)}...`;

//   // Unique key for div to avoid conflicts in lists
//   const divId = `trim-text-div-${
//     index !== undefined ? index : Math.random().toString(36).substr(2, 9)
//   }`;

//   // Toggle expanded state
//   const handleToggle = (e) => {
//     e.stopPropagation();
//     setIsExpanded(!isExpanded);
//   };

//   return (
//     <div
//       className="flex items-end gap-2 cursor-pointer"
//       onClick={handleToggle}
//       role="button"
//       tabIndex={0}
//       aria-expanded={isExpanded}
//       aria-controls={divId}
//       onKeyDown={(e) => {
//         if (e.key === "Enter" || e.key === " ") {
//           e.preventDefault();
//           handleToggle(e);
//         }
//       }}
//     >
//       <span className="text-gray-800">{displayText}</span>
//       {/* {needsTrimming && (
//         <>
//           {isExpanded ? (
//             <TbLayoutSidebarLeftCollapseFilled
//               size={16}
//               className="text-red-600 hover:text-red-800"
//             />
//           ) : (
//             <TbLayoutSidebarRightCollapseFilled
//               size={16}
//               className="text-green-600 hover:text-green-800"
//             />
//           )}
//         </>
//       )} */}
//     </div>
//   );
// };

// // PropTypes for type checking
// TrimText.propTypes = {
//   text: PropTypes.string,
//   index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
//   maxLen: PropTypes.number,
// };

// // Default props for edge cases
// TrimText.defaultProps = {
//   text: "",
//   index: undefined,
//   maxLen: 20,
// };

// export default TrimText;
